import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getManualImageAsset, imageBaseNames } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterSubHeadline } from '../chapterComponents/ChapterSubHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';
import { Fragment } from 'react';
import useDarkMode from '@rio-cloud/rio-uikit/useDarkMode';

type OverviewSection = {
  headline: TranslationsKeys;
  text: TranslationsKeys;
  image: string;
};

export const GetStartedOverviewChapter: React.FC = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();
  const isDarkMode = useDarkMode();

  const overviewImage = getManualImageAsset(
    imageBaseNames.getStarted_overviewOverview,
    locale,
    isDarkMode,
  );

  const sections: OverviewSection[] = [
    {
      headline: 'userManual.getStarted.overview.quickActions.headline',
      text: 'userManual.getStarted.overview.quickActions.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_overviewQuickActions,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.overview.insights.headline',
      text: 'userManual.getStarted.overview.insights.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_overviewYourInsights,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.overview.partners.headline',
      text: 'userManual.getStarted.overview.partners.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_overviewOurPartners,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.overview.resources.headline',
      text: 'userManual.getStarted.overview.resources.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_overviewResources,
        locale,
        isDarkMode,
      ),
    },
  ];

  return (
    <div>
      <div className={'row'}>
        <ChapterHeadline
          messageId={'userManual.getStarted.overview.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            colSizeMd={6}
            messageId={'userManual.getStarted.overview.text'}
          />
          <div className={'col-xs-12 col-md-6 margin-bottom-25'}>
            <ImageLoader
              src={overviewImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.getStarted.overview.headline',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
      <div className={'row margin-top-20'}>
        {sections.map((section) => (
          <Fragment key={section.headline}>
            <ChapterSubHeadline messageId={section.headline} />
            <div
              className={
                'col-xs-12 display-flex gap-25 margin-top-10 margin-bottom-20 flex-column flex-row-md padding-0'
              }
            >
              <ChapterText
                messageId={section.text}
                className={'col-xs-12'}
              />
              <div className={'col-xs-12'}>
                <ImageLoader
                  src={section.image}
                  alt={formatMessage({ id: section.headline })}
                  className={'border'}
                  enlargeable
                />
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
